/**
 * [mutations description]
 * @type {Object}
 */
import abLS from '@/business/abLocalStorage'

var mutations = {
  setUserId(state, userId) {
    state.userId = userId
    abLS.setUserId(userId)
  },
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken
    abLS.setAccessToken(accessToken)
  },
  setHeaderTitle(state, title) {
    document.title = title
    state.headerTitle = title
  },
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo
    abLS.setUserInfo(userInfo)
  },
  setCommonConfigs(state, data) {
    state.commonConfigs = data
  },
  setCurrentRoute(state, data) {
    state.currentRoute = data
  },
  setFromRoute(state, data) {
    state.fromRoute = data
    abLS.setFromRoute(data)
  },
  setShowAuth(state, data) {
    state.showAuthModal = data
  },
  setAuthClose(state, data) {
    state.showAuthClose = data
  },
  setPermissions(state, permissions) {
    state.permissions = permissions
  }
}

export default mutations
